// Global safety net: mark every native date/time input as English locale so
// browsers that pick the picker chrome (calendar / clock popup) from the
// document's Arabic locale still render its labels in Latin digits.
//
// Combined with the CSS in index.css that forces `unicode-bidi: plaintext`
// + `font-feature-settings: "anum" 0` on these inputs, this yields fully
// Latin numeric UIs regardless of the user's browser locale.
if (typeof document !== "undefined") {
  const TARGET = 'input[type="date"], input[type="time"], input[type="datetime-local"], input[type="month"], input[type="week"], input[type="number"]';

  function stamp(el) {
    if (!el || el.getAttribute("lang") === "en") return;
    el.setAttribute("lang", "en");
  }

  function stampAll(root = document) {
    root.querySelectorAll(TARGET).forEach(stamp);
  }

  const kick = () => stampAll();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", kick);
  } else {
    kick();
  }

  // Watch for React-injected inputs and normalize them on mount.
  try {
    const mo = new MutationObserver((mutations) => {
      for (const m of mutations) {
        m.addedNodes.forEach((n) => {
          if (!(n instanceof Element)) return;
          if (n.matches && n.matches(TARGET)) stamp(n);
          if (n.querySelectorAll) n.querySelectorAll(TARGET).forEach(stamp);
        });
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  } catch {
    // MutationObserver unsupported — the initial pass is still applied.
  }
}
